/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetAgentSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetAgentRequest = {
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetAgentSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetAgentSecurity$outboundSchema: z.ZodMiniType<
  GetAgentSecurity$Outbound,
  GetAgentSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getAgentSecurityToJSON(
  getAgentSecurity: GetAgentSecurity,
): string {
  return JSON.stringify(
    GetAgentSecurity$outboundSchema.parse(getAgentSecurity),
  );
}

/** @internal */
export type GetAgentRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetAgentRequest$outboundSchema: z.ZodMiniType<
  GetAgentRequest$Outbound,
  GetAgentRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getAgentRequestToJSON(
  getAgentRequest: GetAgentRequest,
): string {
  return JSON.stringify(GetAgentRequest$outboundSchema.parse(getAgentRequest));
}
